import type { MetaFunction } from "@remix-run/node";
import { getSeoMeta } from "~/utils/seo-meta";
import { SEOLayout } from "~/components/seo/SEOLayout";
import { HubSeoPage } from "~/components/seo/HubSeoPage";
import { getHubGroup } from "~/utils/seo-routes";

const GROUP = getHubGroup("/solutions")!;

export const meta: MetaFunction = () =>
  getSeoMeta({ title: GROUP.hubTitle, description: GROUP.hubDescription, url: GROUP.hubPath });

export default function SolutionsHub() {
  return (
    <SEOLayout>
      <HubSeoPage group={GROUP} />
    </SEOLayout>
  );
}
